import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * StreakBadge: pings /streaks/ping once per session for signed-in users,
 * and shows a small flame with the current streak count. Nothing renders
 * for anon users or when the streak is 0.
 */
export default function StreakBadge() {
  const { user } = useAuth();
  const [streak, setStreak] = useState(null);
  const pingedRef = useRef(false);

  useEffect(() => {
    if (!user || user === false) { setStreak(null); return; }
    if (pingedRef.current) return;
    pingedRef.current = true;
    api.post("/streaks/ping").then((r) => setStreak(r.data)).catch(() => {});
  }, [user]);

  if (!streak || !streak.current_streak) return null;

  const count = streak.current_streak;
  const label = streak.badge?.label || `${count}-day streak`;

  return (
    <div
      data-testid="streak-badge"
      title={label}
      className="hidden sm:flex items-center gap-1.5 px-2.5 py-1 border border-terracotta/40 bg-terracotta/5 text-terracotta text-xs font-medium"
    >
      <Flame className="w-3.5 h-3.5" strokeWidth={2} />
      <span data-testid="streak-count">{count}</span>
      <span className="hidden md:inline text-[10px] uppercase tracking-widest">day{count === 1 ? "" : "s"}</span>
    </div>
  );
}
